const TERMINAL_WORKFLOW_PATHS = Object.freeze({
  cancellation: "cancellation",
  cancel: "cancellation",
  no_show: "no_show",
});

const normalizeReservationId = (value) => {
  const reservationId = Number(value);
  if (!Number.isInteger(reservationId) || reservationId <= 0) {
    throw new Error("A valid reservation ID is required.");
  }
  return reservationId;
};

const normalizeWorkflow = (value) => {
  const workflow = TERMINAL_WORKFLOW_PATHS[String(value || "").trim().toLowerCase()];
  if (!workflow) {
    throw new Error("A supported terminal reservation workflow is required.");
  }
  return workflow;
};

export const buildWaivedTerminalWorkflowRequest = ({
  reservationId,
  workflow,
  cancellationReason,
} = {}) => {
  const safeReservationId = normalizeReservationId(reservationId);
  const safeWorkflow = normalizeWorkflow(workflow);
  const safeCancellationReason = String(cancellationReason || "").trim();

  if (safeWorkflow === "cancellation" && !safeCancellationReason) {
    throw new Error("A cancellation reason is required.");
  }

  return {
    path: `/api/reservations/${safeReservationId}/terminal-workflows/${safeWorkflow}`,
    payload: {
      waive_charge: true,
      ...(safeWorkflow === "cancellation"
        ? { cancellation_reason: safeCancellationReason }
        : {}),
    },
  };
};

export const submitWaivedTerminalWorkflow = async ({
  client,
  apiBaseUrl,
  ...workflowOptions
} = {}) => {
  if (typeof client?.post !== "function") {
    throw new Error("An HTTP client with a post method is required.");
  }

  const request = buildWaivedTerminalWorkflowRequest(workflowOptions);
  const normalizedBaseUrl = String(apiBaseUrl || "").replace(/\/+$/, "");
  return client.post(`${normalizedBaseUrl}${request.path}`, request.payload);
};
